import React, { useEffect, useState } from "react";
import PublicHeader from "../components/PublicHeader";
import PublicFooter from "../components/PublicFooter";
import { api, resolveUrl } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";
import { Star } from "lucide-react";

export default function PublicReviews() {
  const { t, lang } = useI18n();
  const [reviews, setReviews] = useState([]);
  const [stats, setStats] = useState({ count: 0, avg: 0 });

  useEffect(() => {
    api.get("/reviews/site").then((r) => setReviews(r.data)).catch(() => {});
    api.get("/reviews/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <PublicHeader />
      <main className="pt-32 pb-24 max-w-[1440px] mx-auto px-6 md:px-12" data-testid="public-reviews-page">
        <div className="text-center mb-16">
          <div className="label-eyebrow mb-4" style={{ color: "var(--brand-primary)" }}>
            {lang === "en" ? "Client testimonials" : "Marturii clienti"}
          </div>
          <h1 className="font-serif text-5xl mb-6">{lang === "en" ? "What our clients say" : "Ce spun clientii nostri"}</h1>
          {stats.count > 0 && (
            <div className="flex items-center justify-center gap-2">
              <div className="flex gap-0.5">
                {[1,2,3,4,5].map((n) => <Star key={n} className="w-5 h-5" fill={n <= Math.round(stats.avg) ? "var(--brand-primary)" : "none"} stroke="var(--brand-primary)" />)}
              </div>
              <span className="font-serif text-2xl" style={{ color: "var(--brand-primary)" }}>{stats.avg}</span>
              <span className="text-sm" style={{ color: "var(--brand-text-secondary)" }}>&middot; {stats.count} {lang === "en" ? "reviews" : "recenzii"}</span>
            </div>
          )}
        </div>

        {reviews.length === 0 ? (
          <p className="text-center text-sm" style={{ color: "var(--brand-text-secondary)" }}>{lang === "en" ? "No reviews yet." : "Nicio recenzie inca."}</p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {reviews.map((rv) => (
              <div key={rv.id} className="card-surface p-6" data-testid={`site-review-${rv.id}`}>
                <div className="flex items-center gap-1 mb-3">
                  {[1,2,3,4,5].map((n) => <Star key={n} className="w-4 h-4" fill={n <= rv.rating ? "var(--brand-primary)" : "none"} stroke="var(--brand-primary)" />)}
                </div>
                {rv.comment && <p className="text-sm mb-4" style={{ color: "var(--brand-text-secondary)" }}>"{rv.comment}"</p>}
                {rv.media?.length > 0 && (
                  <div className="grid grid-cols-3 gap-2 mb-4">
                    {rv.media.slice(0, 3).map((m) => (
                      <div key={m.id} className="aspect-square overflow-hidden">
                        {m.type === "image" ? <img src={resolveUrl(m.url)} alt="" className="w-full h-full object-cover" /> : <video src={resolveUrl(m.url)} className="w-full h-full object-cover" controls />}
                      </div>
                    ))}
                  </div>
                )}
                <div className="label-eyebrow text-[10px]" style={{ color: "var(--brand-primary)" }}>{rv.guest_name}</div>
              </div>
            ))}
          </div>
        )}
      </main>
      <PublicFooter />
    </div>
  );
}
